import { render, staticRenderFns } from "./sfxx.vue?vue&type=template&id=fd6026a2&"
import script from "./sfxx.vue?vue&type=script&lang=js&"
export * from "./sfxx.vue?vue&type=script&lang=js&"
import style0 from "./sfxx.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports